import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Home as HomeIcon, Store, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";

const MotionLink = motion.create(Link);

const ChoiceBlock = () => {
  const { t } = useLang();
  const c = t.choice;

  const cards = [
    { key: "home", Icon: HomeIcon, to: "/#coffees", testid: "choice-home" },
    { key: "horeca", Icon: Store, to: "/hosteleria", testid: "choice-horeca" },
  ];

  return (
    <section className="bg-[#E6D9B6] py-24 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="text-[#3B2523]/70 uppercase tracking-[0.25em] text-xs font-semibold mb-5 text-center">
            {c.tag}
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-[#3B2523] text-center">
            {c.title}
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mt-14">
          {cards.map(({ key, Icon, to, testid }, i) => (
            <MotionLink
              key={key}
              to={to}
              data-testid={testid}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              className="group block text-left bg-[#F5F1E8] rounded-3xl p-8 md:p-10 border border-[#3B2523]/10 transition-colors hover:border-[#3B2523]/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#3B2523] focus-visible:ring-offset-2"
            >
              <div className="w-14 h-14 rounded-2xl bg-[#3B2523] flex items-center justify-center">
                <Icon size={26} className="text-[#F4D35E]" strokeWidth={1.6} />
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-bold text-[#3B2523] mt-6">
                {c[key].title}
              </h3>
              <p className="text-[#3B2523]/70 text-base mt-3 leading-relaxed max-w-md">
                {c[key].text}
              </p>
              <span className="inline-flex items-center gap-2 mt-6 text-[#3B2523] font-semibold group-hover:gap-3 transition-all">
                {c[key].cta}
                <ArrowRight size={18} />
              </span>
            </MotionLink>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChoiceBlock;
